import { createRouter, createWebHistory } from 'vue-router'

import Home_tool from '@/components/Home.vue'
import Setting_tool from '@/components/Setting.vue'
import Linkaccount_tool from '@/components/Linkaccount.vue'
import Loading_tool from '@/components/Loading.vue'
import BankUpdate_tool from '@/components/BankUpdate.vue'
import BankVib_tool from '@/components/BankVib.vue'
import Bank_tool from '@/components/Bank.vue'
import Result_tool from '@/components/Result.vue'
import RegisterOnline_tool from '@/components/RegisterOnline.vue'
import Notification_tool from '@/components/Notification.vue'
import QR_tool from '@/components/QR.vue'
import QrAccount_tool from '@/components/QrAccount.vue'
import Identifier_tool from '@/components/Identifier.vue'
import Lookup_tool from '@/components/Lookup.vue'

const routes = [
    {
        path: '/',
        name: 'Home_tool',
        component: Home_tool
    },
    {
        path: '/setting',
        name: 'Setting_tool',
        component: Setting_tool
    },
    {
        path: '/notification',
        name: 'Notification_tool',
        component: Notification_tool
    },
    {
        path: '/register-online',
        name: 'RegisterOnline_tool',
        component: RegisterOnline_tool
    },
    {
        path: '/link-account',
        name: 'Linkaccount_tool',
        component: Linkaccount_tool
    },
    {
        path: '/loading',
        name: 'Loading_tool',
        component: Loading_tool
    },
    {
        path: '/bank-update',
        name: 'BankUpdate_tool',
        component: BankUpdate_tool
    },
    {
        path: '/bank-vib',
        name: 'BankVib_tool',
        component: BankVib_tool
    },
    {
        path: '/bank',
        name: 'Bank_tool',
        component: Bank_tool
    },
    {
        path: '/result',
        name: 'Result_tool',
        component: Result_tool
    },
    {
        path: '/qr',
        name: 'QR_tool',
        component: QR_tool
    },
    {
        path: '/qr-account',
        name: 'QrAccount_tool',
        component: QrAccount_tool
    },
    {
        path: '/identifier',
        name: 'Identifier_tool',
        component: Identifier_tool
    },
    {
        path: '/lookup',
        name: 'Lookup_tool',
        component: Lookup_tool
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes: routes,
    linkActiveClass: "active"
})

export default router